import * as React from 'react';

export default class LoggedInToAirbnb extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <h1>
          Successfully sent out invitations to your team members. Please sit tight while we finish importing your Airbnb
          listings.
        </h1>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ConnectListings/ConnectAirbnb/AirbnbLoginSuccess/AirbnbLoginSuccess.tsx